<template>
    <div class="taker-details">
        <el-row :gutter="20">
            <el-col :span="16">
                <div class="details-title">{{ taker.name }}</div>
            </el-col>
            <el-col :span="8">
                <div class="text-right">
                    <el-button
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="editDetails"
                    >Edit</el-button>

                    <el-popover
                        ref="popover"
                        placement="bottom"
                        width="148"
                        trigger="click"
                        popper-class="dark-popper"
                        @hide="hideDeletePopover"
                    >
                        <div>
                            <div class="popover-title">Confirm taker deletion</div>
                            <div class="actions">
                                <el-button type="text" class="decline" @click="hideDeletePopover()">No</el-button>
                                <el-button type="text" class="accept" @click="deleteTaker()">Yes</el-button>
                            </div>
                        </div>
                        <el-button
                            slot="reference"
                            type="danger"
                            class="gcmcn-danger-btn small"
                            :loading="loading"
                            @click="popOverOpened = true"
                        >Delete</el-button>
                    </el-popover>
                </div>
            </el-col>
        </el-row>
        <div class="region">
            <div class="details-label">AWS Region</div>
            <div class="details-value" v-if="taker.aws_region">{{ awsregionsByUid(taker.aws_region).display_name }}</div>
        </div>
        <div
            class="region"
            v-if="taker.client_identifier"
        >
            <div class="details-label">Client ID</div>
            <div class="details-value">{{ taker.client_identifier }}</div>
        </div>
        <div
            v-if="taker"
            class="region"
        >
            <div class="details-label">Entity</div>
            <div class="details-value">{{ entityName }}</div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    components: {
    },
    props: {
        takerUid: {
            type: String,
            required: true
        },
        kickTakerRequests: {
            type: Array,
            required: true
        },

    },

    data: function(){
        return {
            popOverOpenned: false,
            kickRequestUrl: ''
        };
    },

    computed: {
        ...mapGetters([
            'takersByUid',
            'entitiesByUid',
            'awsregionsByUid',
            'groupsByUid'
        ]),
        loading() {
            return this.kickTakerRequests.length > 0;
        },
        taker (){
            return this.takersByUid(this.takerUid);
        },
        entityName(){
            let entity = this.entitiesByUid(this.taker.scopes.entity_uid).name;
            if(entity){
                return entity;
            }
            return 'Entity not found';
        }
    },

    methods: {
        watchKickRequest() {
            this.$store.dispatch('remoteGet', {
                url: this.kickRequestUrl
            }).then(res => {
                if (res.data && ['PENDING', 'DELETING'].includes(res.data.status)) {
                    setTimeout(this.watchKickRequest, 3000)
                } else {
                    this.$store.dispatch('fetchModelByName', 'takers');
                    this.$emit('unselectTaker')
                }
            }).catch((e) => {
                console.error(e);
            })
        },
        deleteTaker() {
            this.$store.dispatch('createItem', {
                item: {
                    taker_uid: this.takerUid
                },
                model: 'kickTakerRequests',
                url: this.$store.state.api.meta.listModels.kickTakerRequests.url,
            }).then((res) => {
                this.$message.success({
                    message: 'Your action has been registered, the taker will be deleted along with its rights and its registrations in the groups'
                })
                this.hideDeletePopover();
                this.kickRequestUrl = res.url;
                this.watchKickRequest();
            }).catch((err) => {
                console.debug(err);
                this.$message.error({
                    message: 'Failed to delete the taker'
                })

            })
        },
        editDetails() {
            this.$emit('editTaker');
        },
        hideDeletePopover() {
            this.popOverOpenned = false;
            if (this.$refs['popover']) {
                this.$refs['popover'].showPopper = false;
            }
        },
    },
};
</script>

<style lang="scss">
.taker-details{
    .ns-loader-spinner {
        height: 80px;
    }
    .region{
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        .details-label {
            font-size: 14px;
            padding: 0;
        }
        .details-value {
            font-size: 14px;
            font-weight: 500;
            margin-left: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Takers/takerDetails.vue